import { Injectable } from '@angular/core';
import { Series } from '@shared/graphql/generated';
import { BaseStoreService } from '@shared/stores/base-store.service';

@Injectable({
  providedIn: 'root'
})
export class FavoriteSeriesStoreService extends BaseStoreService<Series> {
  constructor() {
    super();
  }
}
